import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedLeftAsideComponent } from "./med-left-aside.component";
import { MedIconExpandModule } from "@mk/med-icons";

@NgModule({
  declarations: [
    MedLeftAsideComponent,
  ],
  imports: [
    CommonModule,
    MedIconExpandModule,
  ],
  exports: [
    MedLeftAsideComponent,
  ],
})
export class MedLeftAsideModule { }
